module.exports = __webpack_public_path__ + "img/_icon-calendar_nb.c2f5a0a3.svg";